import React from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react';

import { Status } from 'apps/rfq/rfqPage/views/openRFQ.styled';

import { confToFields } from 'libs/forms';
import { useAppManager } from 'core/hooks';
import StatusSwitcherAppManager from './appManager';

const StatusSwitcherWrapper = styled.div({
  display: 'flex',
  alignItems: 'center',
});

const StatusSwitcherFieldWrapper = styled.div({
  width: '200px',
});

type StatusSwitcherProps = {
  value: string;
  type: 'rfq' | 'order';
  nextPossibleStates: any[];
  onChange: () => {};
};

export const StatusSwitcher = observer((props: StatusSwitcherProps) => {
  const statusSwitcherManager = useAppManager(
    StatusSwitcherAppManager,
    null,
    {
      onChange: props.onChange,
      value: props.value,
      nextPossibleStates: props.nextPossibleStates,
      type: props.type,
    },
    true,
    [props.value, props.nextPossibleStates, props.type],
  );
  return (
    <StatusSwitcherWrapper>
      <span style={{ color: 'black' }}>
        <Status>Status:</Status>
      </span>
      <StatusSwitcherFieldWrapper>
        {confToFields({
          formStore: statusSwitcherManager.formStore,
          refs: {},
          responsive: true,
        })}
      </StatusSwitcherFieldWrapper>
    </StatusSwitcherWrapper>
  );
});
